// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/common/Cards/PatentCard/PatentCard.css
// module id = 882
// module chunks = 0